const spacing = [8, 16, 20, 24, 40];
export default spacing;